import { render, staticRenderFns } from "./BlogsAside.vue?vue&type=template&id=7bb4e68e&scoped=true&"
import script from "./BlogsAside.vue?vue&type=script&lang=js&"
export * from "./BlogsAside.vue?vue&type=script&lang=js&"
import style0 from "./BlogsAside.vue?vue&type=style&index=0&id=7bb4e68e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb4e68e",
  null
  
)

export default component.exports